export const generateSpecialities = (specialities: string[] = []) => {
  if (specialities.length < 2) {
    return specialities[0];
  }

  const headSpecialities = specialities.slice(0, -1);
  return `${headSpecialities.join(',')} and ${specialities.slice(-1)}`;
};
